export default {
  com:{
    login:"登录",
    user_login:'用户登录',
    login_and_registration:"登录/注册",
    registration: '注册',
    customer_center:'游客中心',
    quit:'退出',
    home:'首页',
    the_country:'全国',
    enter_a_keyword: '请输入关键字',
    more:'更多',
    with:'同',
    The_city:'市',
    cur_sign:'¥',
    since:'起',
    Online_offer:'在线优惠',
    My_shop:'我的店铺',
    my:'我的',
    Jump_to_the_shop:'跳转到店铺...',
    error:'出错了！',
    access_computer :'访问电脑版',
    Exit_successfully:'退出成功',
    Set_out:'出发',
    plan:'团期',
    none:'暂无',
    loading:'加载中...',
    No_more_data:'没有更多数据了...',
    Product_screening:'产品筛选',
    Price_range:'价格区间',
    Travel_days:'行程天数',
    unlimited:'不限',
    day:'天',
    day_and_above:'天及以上',
    Departure_date:'出发日期',
    initiate:'开始',
    finish:'结束',
    open_turn_price:'是否开启展示同行价',
    reset:'重置',
    OK:'确定',
    hundred: '百',
    thousand: '千',
    myriad: '万',
    than_myriad: '万以上',
    back:'返回',
    night:'晚',
    NO:'编号',
    Rise_of_man:'人起',
    Enjoy_discount:'可享优惠',
    The_following_prices_are_starting:'以下价格均为起价',
    Select_departure_city:'选择出发城市',
    Itinerary_features:'行程特色',
    Daily_run:'日行程',
    Itinerary_arrangement:'行程安排',
    Cost_statement:'费用说明',
    Cost_included:'费用包含',
    Charges_are_not_included:'费用不包含',
    Trip_information:'行程信息',
    Visa_instructions:'签证说明',
    Visa_attachment:'签证附件',
    Change_the_cancellation_rules:'改退签规则',
    the:'第',
    Have_dinner:'用餐',
    Put_up:'住宿',
    traffic:'交通',
    Itinerary_content:'行程内容',
    Reference_flight:'参考航班',
    Reference_hotel:'参考酒店',
    Matters_needing_attention:'注意事项',
    Contact_number:'联系电话',
    Book_now:'立即预定',
    Preferential_policy:'优惠政策',
    verify:'确认',
    you_are_not_logged_in:'您还未登录，登录后可立即预定',
    you_account_has_not_been_peer_verified:'您的账号还没有进行同行认证哦，请先认证一下吧',
    your_account_has_not_been_approved:'您的账号还未审核通过，审核通过后可下单',
    you_can_continue_booking_after_logging_in:'您还未登录，登录后可继续预定',
    group_data_request_failed:'团期数据请求失败，请稍后再试',
    Relevant_information:'相关信息',
    mobile_phone:'手机',
    submit:'提交',
    Please_fill_in:'请填写',
    Please_enter:'请输入',
    select_date_and_people:'选择日期和人数',
    no_plan:'无团期',
    sunday:'日',
    one:'一',
    two:'二',
    three:'三',
    four:'四',
    five:'五',
    six:'六',
    group:'团',
    clustered:'已成团',
    Departure_city:'出发城市',
    Price_package:'价格套餐',
    information_resource_updated:'由于各资源信息实时更新,价格以订单结算页面价格为准',
    total_amount:'总额',
    detail:'明细',
    Further_booking:'继续预定',
    Expense_detail:'费用明细',
    Basic_tour_fare:'基本团费',
    Grown_man:'成人',
    young:'小年轻',
    Old_Man:'老人',
    child:'小童',
    Children_not_bed:'小童不占床',
    Incidental_expenses:'杂费',
    one_guest_must_selected:'最少需选择一名游客',
    today:'今',
    tomorrow:'明',
    after_tomorrow:'后',
    people:'人',
    year:'年',
    month:'月',
    travel_information_filling:'出游信息填写',
    message:'信息',
    contact_person:'联系人',
    mobile_phone_number:'手机号',
    required:'必填',
    receiving_SMS:'用于接收短信',
    venturette:'出游人',
    order_note:'订单备注',
    sell:'销售',
    Select:'选择',
    submit_an_order:'提交订单',
    tips:'提示',
    Do_you_leave_page:'是否要离开此页面?',
    no:'否',
    yes:'是',
    contact_name:'联系人名称',
    field_required:'是必填项',
    no_more_than_words:'不超过{0}字',
    enter_the_correct_one:'请输入正确的',
    select_Sales:'请选择销售',
    order_expired:'订单已失效',
    order_submitted_being_occupied:'订单已提交，正在占位中',
    id_card_info_not_complete:'的身份证信息未填写完整',
    passport_info_not_complete:'的护照信息未填写完整',
    taiwan_info_incomplete:'的台湾通行证信息未填写完整',
    other_card_info_not_complete:'的其他证件信息未填写完整',
    order_successful:'下单成功',
    contact_name:'联系人姓名',
    bill_info:'账单信息',
    edit_users:'编辑名单',
    ID_card:'身份证',
    Id_number:'身份证号',
    passport:'护照',
    Taiwan_pass:'台湾通行证',
    Chinese_name:'中文名',
    Please_enter_your:'请输入您的',
    English_name:'英文名',
    English_surname:'英文姓',
    sex:'性别',
    birth:'出生日期',
    save:'保存',
    number:'号码',
    Date_of_issue:'签发日期',
    validity:'有效期',
    information_has_been_saved:'已保存您填写的信息',
    selected:'已选择',
    Duplicate_Chinese_name:'中文名重复，请核对',
    Letter_only:'仅为字母',
    format_error:'格式不正确',
    document_information_saved:'证件信息已保存',
    M:'男',
    F:'女',
    document_number:'证件号码',
    letter_only:'仅为字母',
    address:'地址',
    other:'其它',
    user_center:'个人中心',
    registered_member:'注册会员',
    back_home:'回到首页',
    change_password:'修改密码',
    my_order:'我的订单',
    Personal_data:'个人资料',
    Peer_certification:'同行认证',
    nickname:'昵称',
    name:'姓名',
    To_be_reviewed:'待审核',
    audited:'已审核',
    To_be_Submitted:'待提交',
    Login_ban:'禁止登录',
    Declined:'已拒绝',
    Company_name:'公司名称',
    Home_province:'所在省市',
    Detailed_address:'详细地址',
    original:'原',
    new:'新',
    Verify_mobile_phone_number:'验证手机号码',
    Picture_upload:'图片上传',
    Enterprise_information:'企业信息',
    Submit_for_review:'提交审核',
    Please_select:'请选择',
    successfully: '成功',
    please:'请',
    operation:'操作',
    Be_saving:'保存中...',
    change: '修改',
    filter:'筛选',
    order:'订单',
    distribution_order:'分销订单',
    ord_id:'订单编号',
    order_time:'下单时间',
    confirm_ord:'确认单',
    reservation_order:'预留单',
    cancel_ord:'取消单',
    expire:'到期',
    round_trip_date:'往返日期',
    total:'合计',
    nopay:'未付',
    pay:'支付',
    cancel:'取消',
    no_more_orders:'没有更多订单了',
    lose:'失败',
    is_cancel_the_order:'是否取消订单?',
    order_cancelled:'订单取消中...',
    list:'列表',
    Order_status:'订单状态',
    all:'全部',
    valid_ord:'有效单',
    Valid_order:'有效订单',
    Date_type:'日期类型',
    Order_date:'下单日期',
    Departure_date:'出团日期',
    Start_date:'开始日期',
    End_date:'结束日期',
    keyword:'关键字',
    enter_order_number_and_line:'请输入订单号、线路名称',
    search:'搜索',
    Order_details:'订单详情',
    Apply_invoice:'申请发票',
    confirmation:'确认书',
    Letter_departure:'出团通知书',
    Add_on_product:'附加产品',
    commission:'佣金',
    Number_of_people:'人数',
    Number_of_tourists:'游客人数',
    Recommended:'推荐',
    Payment_amount:'付款金额',
    Outbound_information:'出游人信息',
    tourist:'游客',
    unaudited:'未审核',
    add:'新增',
    edit:'编辑',
    addressee:'收件人',
    Not_submitted:'未提交',
    Get_configuration:'获取配置',
    Bank_account_number:'银行账号',
    Click_upload:'点击上传',
    telephone:'电话',
    attachment:'附件',
    My_member:'我的会员',
    Basic_information:'基本信息',
    copy:'复制',
    hold_the_QR_code_share:'长按二维码保存或分享',
    Please_enter_an_integer:'请输入整数',
    Copied:'已复制',
    Please_upload:'请上传',
    Account_number:'账号',
    Effective_singular:'有效单数',
    Commission_rebate:'返佣金额',
    no_data:'无数据...',
    shop:'店铺',
    share:'分享',
    favorite:'收藏',
    product_down:'产品已下架',
    return_prev_page:'返回上一页',
    sorry_page_not_found:'对不起，您访问的页面不存在...',
    you_can_enter_N_characters: '当前还能输入N个文字',
    words_you_entered_exceeded_limit: '你输入的文字数超过限制',
    Peer_password:'同行密码',
    email:'邮箱',
    more_than:'余',
    default_priceName:'默认套餐',
    adult_price:'成人价',
    small_price:'小年轻价',
    oldman_price:'老人价',
    child_price:'小童价',
    not_bed_price:'小童不占床价',
    hk_and_mo_residents:'港澳通行证',

  },

  /////////////////////////////////////////////////以下是登录相关///////////////////////////////
  login:{
    password:'密码',
    enter_your_mobile:'请输入手机号码',
    enter_your_password:'请输入您的密码',
    Sign_now:'立即登录',
    Forgot_password:'忘记密码',
    No_account_Register_now:'没有账号?立即注册',
    third_party_account_log_in:'使用第三方账号登录',
    Log_in:'登录中...',
    Login_failure:'登录失败',
    mobile_or_password_cannot_be_empty:'账号或密码不能为空',
    Login_successful:'登录成功',
    mobile_phone_incorrect:'手机号格式不正确',
    enter_password_6_to_18_characters:'请输入6~18位密码',
    Retrieve_password:'找回密码',
    Graphic_verification_code:'图形验证码',
    Click_Refresh_CAPTCHA:'点击刷新验证码',
    Verification_code:'验证码',
    New_password:'新密码',
    Confirm_password:'确认密码',
    Send_verification_code:'发送验证码',
    verification_code_sent:'验证码已发送，请注意查收',
    resend:'后重新发送',
    two_passwords_different:'两次输入的密码不一致',
    Password_reset:'密码已重置',
    SMS_verification_code:'短信验证码',
    Set_assword:'设置密码',
    Click_done_agree:'点击完成即同意',
    User_agreement:'用户协议',
    Register_now:'立即注册',
    Registered_successfully:'注册成功',
    password_cannot_contain_spaces:'密码不能包含空格',
    You_not_submitted_information:'您还未提交同行认证资料，请完善个人信息',
    information_pending_review:'您的同行认证资料待审核，请耐心等待审核',
    certification_profile_rejected:'您的同行认证资料被拒绝，请重新提交审核',
    your_account_will_be_banned:'您的账号被禁止登录{0}秒后强制退出',
    Upload_business_license:'上传营业执照',
    Next_new_number:'下一步，新号码',
    phone_number_does_not_match:'手机号码不匹配，请重输',
    new_mobile_cannot_original_mobile:'新手机号码不能为原手机号',
    The_format_incorrect:'格式不正确，请重新选择',
    upload_no_more_than_images:'请上传不超过{0}的图片',
    You_can_only_upload_picture:'最多只能上传1张图片',
    Confirm_remove_this_file:'确定移除此文件',
    save_personal_data:'是否保存个人资料?',
  },

  /////////////////////////以下是支付相关/////////////////////////////
  pay:{
    Order_payment:'订单支付',
    Remaining_time_paid:'支付剩余时间',
    This_payment:'本次支付',
    Have_paid:'已支付',
    Payment_installments:'分次支付',
    Alipay_payment:'支付宝支付',
    Wechat_Pay:'微信支付',
    scan_pay:'扫码支付',
    The_how_many_payment:'第{0}次支付',
    Pay_on_deposit:'按定金支付',
    This_minimum_payment:'本次最低支付',
    Pro_rata_payment:'按照比例支付',
    payment_not_less_than:'支付比例不小于',
    There_is_no_limit_amount:'本次不限制支付额度',
    remaining_full_payment:'本次支付剩余全款',
    payment_unlimited:'本次支付不限制额度',
    scan_the_QR_code_complete_payment:'请扫一扫下方二维码完成付款',
    open_wechat_or_Alipay_to_scan_the_code:'请打开微信或支付宝扫码',
    payment_amount_is:'本次支付金额为',
    Paid_full_amount:'全款支付，支付金额为',
    amount_cannot_be_less_than:'输入的金额不能小于{0}',
    click_Payment_in_installments:'请先点击分次支付，输入本次支付金额，再进行',
    Payment_redirection:'支付跳转中...',
  },

  ///////////////////////////////以下是开票相关/////////////////////////////////
  invo:{
    To_be_invoiced:'待开票',
    Billing_status:'开票状态',
    Type_of_invoice:'发票种类',
    Invoice_amount:'开票金额',
    Invoice_title:'发票抬头',
    Taxpayer_identification_number:'纳税人识别号',
    Invoice_type:'发票类型',
    Invoice_has_been_issued:'已开票',
    Paper_invoice:'纸质发票',
    Electronic_invoice:'电子发票',
    Invoice_content:'发票内容',
    Billing_type:'开票种类',
    corporation:'公司',
    personage:'个人',
    Name_of_invoicing_entity:'开票主体名称',
    Bank_of_deposit:'开户行',
    Billing_address:'开票地址',
    Airport_transfer_service_charge:'接送机服务费',
    Travel_service_fee:'旅游服务费',
    invoice_amount_cannot_order_amount:'开票金额不能超过订单金额',
    invoicing_amount_up_amount_order:'开票金额仅允许在订单金额的基础上最多上浮',
    maximum_amount_millions:'输入开票金额上限为千万单位',
    Successful_billing:'开票成功',
  },

  //////////////////以下是我的店铺//////////////////
  myshop:{
    Shop_name:'店铺名称',
    Shop_link:'店铺链接',
    Shop_portrait:'店铺头像',
    click_image_upload_or_modify:'请点击图片进行上传或修改,建议尺寸',
    Shop_sign_picture:'店招图片',
    Store_QR_code:'店铺二维码',
    Price_allocation:'价格配置',
    Function_configuration:'功能配置',
    is_enable_online_ordering:'是否开启在线下单与注册',
    share_your_store_link:'提示:请将您的店铺链接或二维码分享给直客进行访问',
    Direct_visitors:'直客在访问过程中仅会通过您的店铺查看产品,并且游客无法与供应商联系',
    enabled_online_ordering:'你已成功开启在线下单与注册功能',
    turned_off_online_ordering:'你已成功关闭在线下单与注册功能',
    Store_information_saved_successfully:'店铺信息保存成功',
  }
}


// WEBPACK FOOTER //
// ./src/assets/js/i18n/zh_cn.js